<template>
  <div class="ec-wrap">

    <div class="ec-header">
      <div class="ec-header-left">
        <div class="ec-header-icon">
          <feather-icon icon="MailIcon" size="16" />
        </div>
        <div>
          <div class="ec-header-title">Configuracao de Email</div>
          <div class="ec-header-sub">Configure o Resend para envio de emails transacionais (boas-vindas, notificacoes, etc.)</div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="ec-loading">Carregando...</div>

    <template v-else>

      <!-- Provedor -->
      <div class="ec-section">
        <div class="ec-section-title">Provedor de Email</div>
        <div class="ec-provider-card">
          <div class="ec-provider-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="#E86A10" stroke-width="2" stroke-linecap="round"/><path d="M22 6l-10 7L2 6" stroke="#E86A10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div class="ec-provider-info">
            <div class="ec-provider-name">Resend</div>
            <div class="ec-provider-desc">Servico de email transacional moderno e confiavel. Crie sua conta em <a href="https://resend.com" target="_blank" rel="noopener">resend.com</a></div>
          </div>
        </div>
      </div>

      <!-- API Key -->
      <div class="ec-section">
        <div class="ec-section-title">Credenciais</div>
        <div class="ec-field">
          <label class="ec-label">API Key do Resend</label>
          <input v-model="config.api_key" type="password" class="ec-input" placeholder="re_..." />
          <p v-if="config.api_key_masked && !config.api_key" class="ec-hint">Chave atual: {{ config.api_key_masked }}</p>
        </div>
        <div class="ec-row">
          <div class="ec-field">
            <label class="ec-label">Email remetente</label>
            <input v-model="config.from_email" type="email" class="ec-input" placeholder="noreply@seudominio.com" />
            <p class="ec-hint">Deve ser um dominio verificado no Resend</p>
          </div>
          <div class="ec-field">
            <label class="ec-label">Nome do remetente</label>
            <input v-model="config.from_name" type="text" class="ec-input" placeholder="VSLBooster" />
          </div>
        </div>
      </div>

      <!-- Acoes -->
      <div class="ec-actions">
        <button class="ec-btn-save" @click="salvar" :disabled="salvando">
          <feather-icon v-if="!salvando" icon="CheckIcon" size="14" />
          {{ salvando ? 'Salvando...' : 'Salvar configuracao' }}
        </button>
        <button class="ec-btn-test" @click="showTestModal = true" :disabled="!config.from_email">
          <feather-icon icon="SendIcon" size="14" />
          Enviar email de teste
        </button>
      </div>

      <!-- Modal teste -->
      <div v-if="showTestModal" class="ec-modal-overlay" @click.self="showTestModal = false">
        <div class="ec-modal">
          <div class="ec-modal-header">
            <span>Enviar email de teste</span>
            <button class="ec-modal-close" @click="showTestModal = false">✕</button>
          </div>
          <div class="ec-modal-body">
            <div class="ec-field">
              <label class="ec-label">Email de destino</label>
              <input v-model="testEmail" type="email" class="ec-input" placeholder="seu@email.com" />
            </div>
            <button class="ec-btn-save" @click="enviarTeste" :disabled="testando || !testEmail" style="width:100%">
              {{ testando ? 'Enviando...' : 'Enviar teste' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Emailable -->
      <div class="ec-divider"></div>
      <div class="ec-section">
        <div class="ec-section-title">Validação de Email (Emailable)</div>
        <p class="ec-hint" style="margin-bottom:14px">Valida se o email do visitante é real antes de cadastrar. Evita emails falsos e bounces. Crie sua conta em <a href="https://emailable.com" target="_blank" style="color:#E86A10">emailable.com</a></p>
        <div class="ec-field">
          <label class="ec-label">API Key do Emailable</label>
          <input v-model="emailable.api_key" type="password" class="ec-input" placeholder="live_..." />
          <p v-if="emailable.api_key_masked && !emailable.api_key" class="ec-hint">Chave atual: {{ emailable.api_key_masked }}</p>
        </div>
        <div class="ec-actions">
          <button class="ec-btn-save" @click="salvarEmailable" :disabled="salvandoEmailable">
            <feather-icon v-if="!salvandoEmailable" icon="CheckIcon" size="14" />
            {{ salvandoEmailable ? 'Salvando...' : 'Salvar Emailable' }}
          </button>
        </div>
      </div>

    </template>
  </div>
</template>

<script>
export default {
  name: 'EmailConfig',
  data() {
    return {
      loading: true,
      salvando: false,
      salvandoEmailable: false,
      emailable: { api_key: '', api_key_masked: '' },
      testando: false,
      showTestModal: false,
      testEmail: '',
      config: {
        provider: 'resend',
        api_key: '',
        api_key_masked: '',
        from_email: '',
        from_name: 'VSLBooster',
      },
    }
  },
  mounted() { this.carregar(); this.carregarEmailable() },
  methods: {
    api() { return process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend' },
    async carregar() {
      try {
        const resp = await fetch(`${this.api()}/email-config`)
        const data = await resp.json()
        if (data && data.from_email) {
          this.config = { ...this.config, ...data, api_key: '' }
        }
      } catch (e) { console.error(e) }
      finally { this.loading = false }
    },
    async salvar() {
      if (!this.config.api_key && !this.config.api_key_masked) {
        this.$message({ type: 'error', message: 'API Key obrigatoria' })
        return
      }
      this.salvando = true
      try {
        const payload = { ...this.config }
        if (!payload.api_key && this.config.api_key_masked) delete payload.api_key
        const resp = await fetch(`${this.api()}/email-config`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
        const data = await resp.json()
        if (resp.ok) {
          this.$message({ type: 'success', message: 'Configuracao salva!' })
          this.carregar()
        } else {
          this.$message({ type: 'error', message: data.error || 'Erro ao salvar' })
        }
      } catch (e) {
        this.$message({ type: 'error', message: 'Erro de conexao' })
      } finally { this.salvando = false }
    },
    async carregarEmailable() {
      try {
        const resp = await fetch(`${this.api()}/emailable-config`)
        const data = await resp.json()
        if (data && data.api_key_masked) this.emailable = { api_key: '', api_key_masked: data.api_key_masked }
      } catch (e) { /* silencioso */ }
    },
    async salvarEmailable() {
      if (!this.emailable.api_key && !this.emailable.api_key_masked) {
        this.$message({ type: 'error', message: 'API Key obrigatória' }); return
      }
      this.salvandoEmailable = true
      try {
        const payload = {}
        if (this.emailable.api_key) payload.api_key = this.emailable.api_key
        const resp = await fetch(`${this.api()}/emailable-config`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        if (resp.ok) {
          this.$message({ type: 'success', message: 'Emailable configurado!' })
          this.carregarEmailable()
        } else {
          const d = await resp.json(); this.$message({ type: 'error', message: d.error || 'Erro' })
        }
      } catch (e) { this.$message({ type: 'error', message: 'Erro de conexão' }) }
      finally { this.salvandoEmailable = false }
    },
    async enviarTeste() {
      this.testando = true
      try {
        const resp = await fetch(`${this.api()}/email-config/test`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ to_email: this.testEmail }),
        })
        const data = await resp.json()
        if (resp.ok) {
          this.$message({ type: 'success', message: 'Email de teste enviado!' })
          this.showTestModal = false
        } else {
          this.$message({ type: 'error', message: data.error || 'Erro ao enviar' })
        }
      } catch (e) {
        this.$message({ type: 'error', message: 'Erro de conexao' })
      } finally { this.testando = false }
    },
  },
}
</script>

<style scoped>
.ec-wrap { padding: 28px 32px; max-width: 700px; }

.ec-header { display: flex; align-items: center; gap: 12px; margin-bottom: 28px; }
.ec-header-left { display: flex; align-items: center; gap: 12px; }
.ec-header-icon { width: 40px; height: 40px; border-radius: 10px; background: rgba(232,106,16,0.1); display: flex; align-items: center; justify-content: center; color: #E86A10; flex-shrink: 0; }
.ec-header-title { font-size: 15px; font-weight: 700; color: var(--dk-text-primary, #e2e8f0); }
.ec-header-sub { font-size: 12px; color: var(--dk-text-muted, #8a94a6); margin-top: 2px; }

.ec-loading { text-align: center; padding: 40px; color: var(--dk-text-muted); }

.ec-section { margin-bottom: 24px; }
.ec-section-title { font-size: 12px; font-weight: 700; color: #E86A10; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 12px; }

.ec-provider-card { display: flex; align-items: center; gap: 14px; padding: 16px; border-radius: 10px; background: rgba(232,106,16,0.04); border: 1px solid rgba(232,106,16,0.15); }
.ec-provider-icon { flex-shrink: 0; }
.ec-provider-name { font-size: 14px; font-weight: 700; color: var(--dk-text-primary, #e2e8f0); }
.ec-provider-desc { font-size: 12px; color: var(--dk-text-muted, #8a94a6); margin-top: 2px; }
.ec-provider-desc a { color: #E86A10; text-decoration: none; }
.ec-provider-desc a:hover { text-decoration: underline; }

.ec-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.ec-field { margin-bottom: 14px; }
.ec-label { display: block; font-size: 12px; font-weight: 600; color: var(--dk-text-primary, #e2e8f0); margin-bottom: 6px; }
.ec-input { width: 100%; padding: 10px 14px; background: rgba(255,255,255,0.04); border: 1.5px solid rgba(255,255,255,0.1); border-radius: 8px; color: var(--dk-text-primary, #e2e8f0); font-size: 13px; font-family: inherit; outline: none; transition: border-color 0.2s; box-sizing: border-box; }
.ec-input:focus { border-color: #E86A10; }
.ec-hint { font-size: 11px; color: var(--dk-text-muted, #64748b); margin-top: 4px; }

.ec-actions { display: flex; gap: 10px; margin-top: 24px; }
.ec-btn-save { display: inline-flex; align-items: center; gap: 8px; padding: 11px 24px; border-radius: 10px; border: none; background: linear-gradient(135deg, #E86A10, #d45e0c); color: #fff; font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit; box-shadow: 0 4px 14px rgba(232,106,16,0.3); transition: all 0.2s; }
.ec-btn-save:hover:not(:disabled) { transform: translateY(-1px); }
.ec-btn-save:disabled { opacity: 0.5; cursor: not-allowed; }
.ec-btn-test { display: inline-flex; align-items: center; gap: 8px; padding: 11px 24px; border-radius: 10px; border: 1.5px solid rgba(255,255,255,0.12); background: rgba(255,255,255,0.04); color: var(--dk-text-primary, #e2e8f0); font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; transition: all 0.2s; }
.ec-btn-test:hover:not(:disabled) { border-color: rgba(255,255,255,0.25); }
.ec-btn-test:disabled { opacity: 0.4; }

.ec-modal-overlay { position: fixed; inset: 0; z-index: 9999; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; padding: 20px; }
.ec-modal { background: var(--dk-bg-card, #1a2535); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; width: 100%; max-width: 400px; overflow: hidden; }
.ec-modal-header { display: flex; align-items: center; justify-content: space-between; padding: 18px 22px; border-bottom: 1px solid rgba(255,255,255,0.06); font-weight: 700; color: var(--dk-text-primary, #e2e8f0); }
.ec-modal-close { background: none; border: none; color: var(--dk-text-muted); cursor: pointer; font-size: 18px; }
.ec-modal-body { padding: 22px; }
.ec-divider { height: 1px; background: rgba(255,255,255,0.06); margin: 32px 0; }
</style>
